import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ClientAssessmentsListScreen } from '@/features/assessments/components/client/ClientAssessmentsListScreen';

const searchSchema = z.object({
  tab: z.enum(['pending', 'completed']).optional(),
});

export const Route = createFileRoute('/client/assessments/')({
  validateSearch: searchSchema,
  component: ClientAssessmentsRoute,
});

function ClientAssessmentsRoute() {
  return <ClientAssessmentsListScreen />;
}
